import Api from './api'
import ApiTest from './api_test'


export const getBase64 = () =>
    {

        return Api().get('base64', {
            headers: {
                "Content-Type": "application/json"
            }
        })

    }
    
export async function  getProyecto()
    {
        var idProyecto = '60abc6936ca0ba0017b96fd9';

        return Api().get('/api/proyectos/get/'+idProyecto, {
            headers: {
                "Content-Type": "application/json",
                "x-api-key": "1Nt3r4ct1v3",
            }
        })
    }


export async function  getProyectos() 
{


    return Api().get('/api/proyectos/get/', {
        headers: {
            "Content-Type": "application/json",
            "x-api-key": "1Nt3r4ct1v3",
        }
    })
}

export async function  getDropboxFiles()
{
    var data = { path: "/Constructoras/Prodesa/Castelo/" }

    return Api().post('/api/dropbox/file-list', data, {
        headers: {
            "Content-Type": "application/json",
            "x-api-key": "1Nt3r4ct1v3",
        }
    })
}


export const createEmail = (payload) =>
{

    let {name, email, phone, emailConstructora, nombreConstructora, nombreProyecto, idProyecto } = payload;
    
    var data = { 
        Nombre: name,
        Email: email,
        Telefono: phone,
        Constructora: nombreConstructora,
        Proyecto: nombreProyecto,
        EmailConstructora: emailConstructora,
        idProyecto: idProyecto,
        // File: 
        //  { value: 'fs.createReadStream("samplePlano.jpg")',
        //    options: { filename: 'samplePlano.jpg', contentType: null } },

        //ContentArray: '{"Aptos":[{"Nombre":"A1-1","Areas":["34.5","38.8"]},{"Nombre":"C1-1","Areas":["54.5","59.5"]}]}',
        //Convert To Json 
        //ContentArray: `{"Aptos": ${JSON.stringify(aptosCotizados)}}`,
        //Constructora: 'IC Constructora',
        //Proyecto: 'Primera Este',
        //idProyecto: '5f610c3e525a671c1099c708' ,
        //EmailConstructora: 'icconstructora@metisbpo.com',
    
    }
    
    //si esta pasando por acá?
    return ApiTest().post('/api/cotizaciones/createEmail', data, {
        headers: {
            "Content-Type": 'application/json',
            "x-api-key": "1Nt3r4ct1v3",
        }
    })
}

export const insertCotizacion = (payload) =>
{

    //var idPrimeraEste = "5f610c3e525a671c1099c708" //bd real y test
    let { name, email, phone, emailConstructora, nombreConstructora, nombreProyecto } = payload;
    let numerosAptos = [];

    /*aptosCotizados.forEach(element => {
        numerosAptos.push(element.Numero);
    });*/


    var data = { 
        Nombre: name,
        Email: email,
        Telefono: phone,
        Constructora: nombreConstructora,
        Proyecto: nombreProyecto,
        EmailConstructora: emailConstructora,
        //Aptos: JSON.stringify(numerosAptos), //JSON.stringify(aptosCotizados),
    }
    
    //si esta pasando por acá?
    return ApiTest().put(`/api/cotizaciones/update/${data.idProyecto}`, data, {
        headers: {
            "Content-Type": 'application/json',
            "x-api-key": "1Nt3r4ct1v3",
        }
    })
}


